var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4V3a1 1 0 10-2 0v1l-3.129.046L13 4h-1.871v.046H8V3a1 1 0 00-2 0v1.046H4a1 1 0 00-1 1V20a1 1 0 001 1h16a1 1 0 001-1V5.03a1 1 0 00-.985-.999L18 4zm1 15H5V9h14v10zM7 11v2h2v-2H7zm4 0h2v2h-2v-2zm4 0v2h2v-2h-2zm-8 6v-2h2v2H7zm6-2h-2v2h2v-2zm2 2v-2h2v2h-2z",
    fill: "#9CA6AD"
  })));
};

export default SvgCalendar;